import { useNewMemberDialog } from '@utils/dialogs-hooks';
import { ThemeButton } from '@shared/ui/buttons';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export default function InviteMemberBtn() {
  const { t } = useTranslation();
  const { openNewMemberDialog } = useNewMemberDialog();
  const { group } = useSelector((state) => state.group_id);

  return (
    <ThemeButton
      appearance={group ? 'primary' : 'secondary'}
      startIcon="profile"
      onClick={() => openNewMemberDialog(group || null)}
      block={false}
    >
      {t('invite_member')}
    </ThemeButton>
  );
}
